define(
    'modals/secured/explorer/details/tabs/actions/DocumentActionUnDeleteModal',[
        "plugins/dialog",
        "i19n!i19n/strings"
    ],
    function (dialog, i19n) {

        function Modal() {
            var self = this;

            self.i19n = i19n;
            self.documents = ko.observableArray();
            self.isBusy = ko.observable(false);
            self.numberOfClicks = ko.observable(0);
            self.hasClicked = ko.observable(true);

            self.DisabledPrimaryClass = ko.computed(function () {
                if (this.numberOfClicks() >= 1)
                    return "btn btn-block btn-primary disabled";
                else
                    return "btn btn-block btn-primary";
            }, self);

            self.DisabledDefaultClass = ko.computed(function () {
                if (this.numberOfClicks() >= 1)
                    return "btn btn-block disabled";
                else
                    return "btn btn-block ";
            }, self);
       }

   
        Modal.prototype = {
            activate: function () {
                var self = this;
            },
            undeleting: function () {
                var self = this;

                dialog.close(self, { undeleting: true });
            },
            cancel: function () {
                var self = this;

                dialog.close(self, { cancel: true });
            }
        };

        return Modal;
    }
);
